// API search symbol types that support transactions.
// See areTransactionsSupported in domain/transactions-behavior.ts and keep this in sync.
// TODO from Nikola: ideally, these would somehow be unified and more strictly kept in sync with the domain behavior logic in domain/transactions-behavior.ts.
const TRANSACTABLE_SYMBOL_SEARCH_TYPES = [
  'cryptoSymbol',
  'symbol',
  'etfSymbol',
];

// TODO from Nikola: ideally this would just return the list of types (['cryptoSymbol', 'symbol', 'etfSymbol']) and let the actual API client (search() in plugins/api/search.ts) do the joining/formatting as the API expects it.
/**
 * The search endpoint's parameter of search-type that only provides results that support transactions. This is a comma-separated list of search-type keys.
 *
 * @returns {string} A comma-separated list of search-type keys.
 */
export function getTransactableSymbolSearchTypes(): string {
  return TRANSACTABLE_SYMBOL_SEARCH_TYPES.join(',');
}
